import React from 'react';
import "../../../assets/scss/map-control.scss"

const LiveConsoleIcon = ({ onClick }) => {
    return <div
        title="Live Console"
        className={`square-control live-console`}
        onClick={onClick}>
        <i className="fa fa-cogs" aria-hidden="true" />
    </div>
};

export default LiveConsoleIcon;